import api from '../../../services/api';

export const SubscriptionsHTTP = {
  getPortalLink: () => api.get('/subscriptions/portal'),
  update: (id = '', payload = {}) => api.put(`/subscriptions/${id}`, payload),
  cancel: (payload = {}) => api.post('/subscriptions/cancel', payload),
};
